<template>
  <b-container>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <h5 style="text-align: center;">Add new Option</h5>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-col cols="1">
              <a :href="'#'+$route.path"><b-icon icon="plus-circle" variant="primary" font-scale="2.5" v-b-popover.hover.left="'Add new Option'" @click="addOption()"></b-icon></a>
            </b-col> -->
            <b-col>
              <b-form-input v-model="newOption.name" placeholder="Option name"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="py-2">
            <b-col cols="5">
              <b-form-input id="add_price" v-model="newOption.add_price" placeholder="Extra price"></b-form-input>
            </b-col>
            <b-col cols="4">
              <label for="select_qty" style="float: right;">Select qty<br/> (0 = unlimited)</label>
            </b-col>
            <b-col cols="3">
              <b-form-input id="select_qty" v-model="newOption.select_qty" type="number"></b-form-input>
            </b-col>
            <!-- <b-col cols="4">
              <b-form-group>
                <b-form-radio-group
                  v-model="newOption.select_qty"
                  :options="[{text: 'Pick multiple', value: 0},{text: 'Pick one only', value: 1}]"
                ></b-form-radio-group>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row class="py-2">
            <b-col style="text-align:center;">
              <b-button variant="outline-dark" @click="addOption()">Add</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10"><b-alert v-if="newoptionalert" variant="info" v-model="newoptionalert" dismissible>Please enter an Option name!</b-alert></b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <h5 style="text-align: center;">Edit Options</h5>
            </b-col>
          </b-row>
          <b-list-group>
            <OptionList
              v-for="option of options"
              v-bind:option="option"
              v-bind:key="option.id"
              @emit-fetch-options="fetchMenuOptions"
              @emit-switch-overlay="switchOverlay">
            </OptionList>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="currentPage" :total-rows="total_options" :per-page="limit" align="center" @change="showoverlay=true; fetchMenuOptions()"></b-pagination>
          <p style="text-align: center;">Total options: {{ total_options }}</p>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import OptionList from '@/components/OptionList.vue'
export default {
  name: "MenuOptions",
  components: {
    OptionList
  },
  data() {
    return {
      options: [],
      total_options: 0,
      limit: 50,
      currentPage: 1,
      showoverlay: false,
      newOption: {
        name: '',
        add_price: '',
        select_qty: 0
      },
      newoptionalert: false
    };
  },

  computed: {
    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      return "?page="+this.currentPage+"&limit="+this.limit;
    }
  },

  methods: {

    switchOverlay(bool) {
      this.showoverlay = bool;
    },

    async addOption() {
      if (this.newOption.name == '') {
        this.newoptionalert = true;
        return;
      }
      this.switchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.newOption.name,
        "add_price": this.newOption.add_price,
        "select_qty": this.newOption.select_qty
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('optionheaders',
        body,
        config
      );
      if (data.created == true) {
        this.newOption = [];
        this.fetchMenuOptions();
      } else {
        this.showoverlay=false;
        this.$bvModal.msgBoxOk('There was a problem adding the option, please try again later.', {
          title: 'Error adding option',
          centered: true
        })
      }
    },

    async fetchMenuOptions() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("optionheaders"+this.urlext, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      try {
        this.options = await data.optionheaders;
        this.total_options = data.total_options;
        this.switchOverlay(false);
      } catch(e) {
        console.log(e);
        this.switchOverlay(false);
      }
    },

  },

  created: function() {
    // this.switchOverlay(true);
    this.fetchMenuOptions();
  }
}
</script>
